"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.skipLinkStyle = exports.WrapperTag = exports.SideBar = exports.MainContent = exports.FooterWrapper = exports.Content = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
var _styles = require("../../globals/styles/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const withoutSideBar = process.env.NODE_ENV === "production" ? {
  name: "1t8kox4",
  styles: "padding-bottom:80px"
} : {
  name: "1j7sf2l-withoutSideBar",
  styles: "padding-bottom:80px;label:withoutSideBar;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const withSideBar = process.env.NODE_ENV === "production" ? {
  name: "75b7ct",
  styles: "display:grid;grid-template-columns:1fr 1fr;width:100vw"
} : {
  name: "tg3hn-withSideBar",
  styles: "display:grid;grid-template-columns:1fr 1fr;width:100vw;label:withSideBar;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const WrapperTag = exports.WrapperTag = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "ercarvp4"
} : {
  target: "ercarvp4",
  label: "WrapperTag"
})(props => /*#__PURE__*/(0, _react.css)(props.sideBarWidth && withSideBar, " ", !props.sideBarWidth && withoutSideBar, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:WrapperTag;")));
const MainContent = exports.MainContent = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "ercarvp3"
} : {
  target: "ercarvp3",
  label: "MainContent"
})(props => /*#__PURE__*/(0, _react.css)("display:", props.sideBarWidth ? 'flex' : 'grid', ";width:", props.sideBarWidth ? `calc(100vw - ${props.sideBarWidth})` : '100%', ";flex-direction:row;transition:width 0.2s ease-in-out;" + (process.env.NODE_ENV === "production" ? "" : ";label:MainContent;")));
const FooterWrapper = exports.FooterWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "ercarvp2"
} : {
  target: "ercarvp2",
  label: "FooterWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "pyv407",
  styles: "grid-column:2/3"
} : {
  name: "pyv407",
  styles: "grid-column:2/3",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const SideBar = exports.SideBar = /*#__PURE__*/(0, _base.default)("aside", process.env.NODE_ENV === "production" ? {
  target: "ercarvp1"
} : {
  target: "ercarvp1",
  label: "SideBar"
})(props => /*#__PURE__*/(0, _react.css)("position:relative;width:", props.sideBarWidth, ";transition:width 0.2s ease-in-out;" + (process.env.NODE_ENV === "production" ? "" : ";label:SideBar;")));
const Content = exports.Content = /*#__PURE__*/(0, _base.default)("main", process.env.NODE_ENV === "production" ? {
  target: "ercarvp0"
} : {
  target: "ercarvp0",
  label: "Content"
})(process.env.NODE_ENV === "production" ? {
  name: "1inpstx",
  styles: "display:flex;flex-direction:column;min-height:calc(100vh - 60px - 60px);width:100%;margin-top:60px"
} : {
  name: "1inpstx",
  styles: "display:flex;flex-direction:column;min-height:calc(100vh - 60px - 60px);width:100%;margin-top:60px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const skipLinkStyle = theme => /*#__PURE__*/(0, _react.css)("position:fixed;z-index:-9999;top:1px;left:-999px;overflow:hidden;width:1px;height:1px;border:none;&:focus-visible{", _styles.defaultOutline, " width:auto;height:auto;overflow:auto;z-index:9999;left:1px;padding:5px;background:", theme.info, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:skipLinkStyle;"));
exports.skipLinkStyle = skipLinkStyle;